"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /**
   * 设置值
   * @param {string} name  名字key
   * @param {string} value 值
   * @param {number} days  失效时间，1/天
   * @param {string} path  路径，默认/
   * @param {string} domain 域名设置
   */
  set: function set(name, value, days, path, domain) {
    // server side
    if (typeof document === 'undefined') {
      return '';
    }

    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=".concat(date.toGMTString());
    }

    var dir = path || '/';

    if (domain) {
      document.cookie = "".concat(name, "=").concat(value).concat(expires, "; domain=").concat(domain, "; path=").concat(dir);
      return;
    }

    document.cookie = "".concat(name, "=").concat(value).concat(expires, "; path=").concat(dir);
  },

  /**
   * 获取cookie
   * @param {string} name  名字key
   */
  get: function get(name) {
    // server side
    if (typeof document === 'undefined') {
      return '';
    }

    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i += 1) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }

    return '';
  },

  /**
   * 删除cookie
   * @param {string} name  名字key
   */
  remove: function remove(name) {
    this.set(name, '', -1);
  }
};
exports.default = _default;